import { SCol, SRow } from '@avalara/skylab-sdk/react';
import { useSelector } from 'react-redux';
import conf from '../../../conf';
import { useAppDispatch } from '../../../hooks/use-app-dispatch';
import { exitQuestionnaire } from '../../../lib/side-effects/prequal-questionnaire';
import { selectState } from '../../../selectors';
import { getCtaUrlWithCampaignId } from '../../helpers/prequal-questionnaire';
import RegistrationsNextSteps from './registrations-next-steps';

const EndPage = () => {
  const dispatch = useAppDispatch();
  const {
    questionnaire: { config },
  } = useSelector(selectState);
  const endPageData = config?.endPage.content;
  if (config?.name === 'registrations') return <RegistrationsNextSteps />;

  if (!endPageData) {
    return null;
  }
  const campaignId = config?.campaignId || '';
  const ctaButtonUrl = getCtaUrlWithCampaignId(campaignId, `${conf.BUY_CLIENT_URL}${endPageData.actionButtonUrl}`);
  const ctaLink1Url = getCtaUrlWithCampaignId(campaignId, `${conf.BUY_CLIENT_URL}${endPageData.actionLink1Url}`);
  const ctaLink2Url = getCtaUrlWithCampaignId(campaignId, endPageData.actionLink2Url);

  return (
    <div className='App-page'>
      <SRow className='margin-left-xl margin-top-xl margin-right-xl'>
        <SCol span='md-7 8' className='pad-bottom-none'>
          <h1 data-ref='buy.prequal.endPage.header' className='margin-bottom-md'>
            {endPageData.heading}
          </h1>
          <p data-ref='buy.prequal.endPage.body'>{endPageData.body}</p>
          <p data-ref='buy.prequal.endPage.subtext' className='font-bold margin-top-xl'>
            {endPageData.subText}
          </p>
          <div className='flex flex-dir-row align-items-center margin-top-xl pad-bottom-xl'>
            <button
              type='button'
              data-ref='buy.prequal.endPage.exit-button'
              className='primary'
              onClick={() => dispatch(exitQuestionnaire(ctaButtonUrl))}
            >
              {endPageData.actionButtonText}
            </button>
            <p className='margin-left-xs'>{' or '} </p>
            <button
              type='button'
              data-ref='buy.prequal.endPage.exit-link'
              className='link text-underline pad-left-xs justify-bottom'
              onClick={() => dispatch(exitQuestionnaire(ctaLink1Url))}
            >
              {endPageData.actionLink1Text}
            </button>
          </div>
          <div className='flex flex-dir-row align-items-center margin-top-xl'>
            <p>{endPageData.actionLink2Text}</p>
            <a
              data-ref='buy.prequal.endPage.action-subText'
              className='text-underline pad-left-xs'
              href={ctaLink2Url}
              target='_blank'
              rel='noreferrer'
            >
              {endPageData.actionLink2SubText}
            </a>
          </div>
        </SCol>
        <SCol span='md-5 4' className='pad-bottom-none'>
          <img
            data-ref='buy.prequal.endPage.image'
            src={`${conf.ASSET_PATH}/assets/images/prequal/${endPageData.imageFile}`}
            alt=''
            style={{ minWidth: '301px' }}
          />
        </SCol>
      </SRow>
    </div>
  );
};
export default EndPage;
